module.exports = "/_next/static/images/vg-47fe9060485e127e90a7c6ae93324930.svg";